import { useNavigate } from "react-router-dom";
import "./VillageLayout.css";
import { useTranslation } from "react-i18next";
import VillageGallery from "./VillageGallery";
import Heading from "./Heading";


const VillageLayout = ({ className = "" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleViewAllClick = () => {
    navigate("/our-village");
  };

  return (
    <div className={`village-layout ${className}`.trim()}>
      {/* Header Section */}
      <div className="village-header">
        <div className="village-title-section">
          <Heading title={t("village.title")} />
        </div>
        <button 
          className="village-view-all-button max-sm:hidden block"
          onClick={handleViewAllClick}
        >
          {t("village.viewAllButton")}
        </button>
      </div>
      <VillageGallery />
      <button 
        className="village-view-all-button max-sm:block hidden"
        onClick={handleViewAllClick}
      >
          {t("village.viewAllButton")}
        </button>
    </div>
  );
};

export default VillageLayout;
